import React, { useEffect, useState } from "react";
import ReactCrop from "react-image-crop";
import useForm from "../useForm";

function CropImageView({ file, onBackArrowClick, onSubmitClick }) {
  const [crop, setCrop] = useState({
    aspect: 1 / 1,
    x: 0,
    y: 0,
    width: 200,
    height: 200,
    unit: "px",
  });
  const [image, setImage] = useState(null);
  // const [preview, setPreview] = useState(null);
  // const [file, setFile] = useState(null);

  const cropImageNow = (onBlobReady) => {
    const canvas = document.createElement("canvas");
    const scaleX = image.naturalWidth / image.width;
    const scaleY = image.naturalHeight / image.height;
    canvas.width = crop.width;
    canvas.height = crop.height;
    const ctx = canvas.getContext("2d");

    const pixelRatio = window.devicePixelRatio;
    canvas.width = crop.width * pixelRatio;
    canvas.height = crop.height * pixelRatio;
    ctx.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0);
    ctx.imageSmoothingQuality = "high";

    ctx.drawImage(
      image,
      crop.x * scaleX,
      crop.y * scaleY,
      crop.width * scaleX,
      crop.height * scaleY,
      0,
      0,
      crop.width,
      crop.height
    );

    // Converting to base64
    // const base64Image = canvas.toDataURL("image/jpeg");
    // setPreview(base64Image);

    canvas.toBlob(blob => {
      blob.lastModifiedDate = new Date();
      blob.name = "cropped-image.png";
      onBlobReady(blob);
    },
    "image/png",
    1,
    )
  };

  return (
    <div>
      <div className="activeBox-headBox">
        <svg
          className="activeBox-back"
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          onClick={onBackArrowClick}
        >
          <path
            d="M16 7H3.83L9.415 1.415L8 0L0 8L8 16L9.415 14.585L3.83 9H16V7Z"
            fill="#787878"
          />
        </svg>
        <h4 className="activeBox-title">Wykadruj zdjęcie i zaakceptuj</h4>
      </div>
      <p className="activeBox-text">
        Przed wysłaniem wybierz odpowiedni kadr dla swojego zdjęcia.
        <br />
        Następnie kliknij przycisk "Akceptuję" aby je zaktualizować i ustawić w
        stopce.
      </p>

      <div className="dropdown-content crop-content">
        <div className="cropArea__flex">
          <div className="cropArea__crop">
            <div className="cropArea__crop-cropper">
              <ReactCrop
                src={file}
                onImageLoaded={setImage}
                crop={crop}
                onChange={setCrop}
                minWidth={200} 
                minHeight={200}
              />
            </div>
          </div>
          <div className="cropArea__how">
            <p className="cropArea__how-head">
              Jak poprawnie kadrować zdjęcie?
            </p>
            <div className="cropArea__how-container">
              <div className="cropArea__how-box">
                <p className="cropArea__how-text">Źle wykadrowane zdjęcie</p>
                <span className="cropArea__how-infoIcon info-wrong">
                  <svg
                    width="12"
                    height="12"
                    viewBox="0 0 12 12"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M7 9.75V8.25C7 8.17708 6.97656 8.11719 6.92969 8.07031C6.88281 8.02344 6.82292 8 6.75 8H5.25C5.17708 8 5.11719 8.02344 5.07031 8.07031C5.02344 8.11719 5 8.17708 5 8.25V9.75C5 9.82292 5.02344 9.88281 5.07031 9.92969C5.11719 9.97656 5.17708 10 5.25 10H6.75C6.82292 10 6.88281 9.97656 6.92969 9.92969C6.97656 9.88281 7 9.82292 7 9.75ZM9 4.5C9 4.04167 8.85547 3.61719 8.56641 3.22656C8.27734 2.83594 7.91667 2.53385 7.48438 2.32031C7.05208 2.10677 6.60938 2 6.15625 2C4.89062 2 3.92448 2.55469 3.25781 3.66406C3.17969 3.78906 3.20052 3.89844 3.32031 3.99219L4.35156 4.77344C4.38802 4.80469 4.4375 4.82031 4.5 4.82031C4.58333 4.82031 4.64844 4.78906 4.69531 4.72656C4.97135 4.3724 5.19531 4.13281 5.36719 4.00781C5.54427 3.88281 5.76823 3.82031 6.03906 3.82031C6.28906 3.82031 6.51172 3.88802 6.70703 4.02344C6.90234 4.15885 7 4.3125 7 4.48438C7 4.68229 6.94792 4.84115 6.84375 4.96094C6.73958 5.08073 6.5625 5.19792 6.3125 5.3125C5.98438 5.45833 5.68359 5.68359 5.41016 5.98828C5.13672 6.29297 5 6.61979 5 6.96875V7.25C5 7.32292 5.02344 7.38281 5.07031 7.42969C5.11719 7.47656 5.17708 7.5 5.25 7.5H6.75C6.82292 7.5 6.88281 7.47656 6.92969 7.42969C6.97656 7.38281 7 7.32292 7 7.25C7 7.15104 7.05599 7.02214 7.16797 6.86328C7.27995 6.70443 7.42188 6.57552 7.59375 6.47656C7.76042 6.38281 7.88802 6.30859 7.97656 6.25391C8.0651 6.19922 8.1849 6.10807 8.33594 5.98047C8.48698 5.85286 8.60286 5.72786 8.68359 5.60547C8.76432 5.48307 8.83724 5.32552 8.90234 5.13281C8.96745 4.9401 9 4.72917 9 4.5ZM12 6C12 7.08854 11.7318 8.09245 11.1953 9.01172C10.6589 9.93099 9.93099 10.6589 9.01172 11.1953C8.09245 11.7318 7.08854 12 6 12C4.91146 12 3.90755 11.7318 2.98828 11.1953C2.06901 10.6589 1.34115 9.93099 0.804688 9.01172C0.268229 8.09245 0 7.08854 0 6C0 4.91146 0.268229 3.90755 0.804688 2.98828C1.34115 2.06901 2.06901 1.34115 2.98828 0.804688C3.90755 0.268229 4.91146 0 6 0C7.08854 0 8.09245 0.268229 9.01172 0.804688C9.93099 1.34115 10.6589 2.06901 11.1953 2.98828C11.7318 3.90755 12 4.91146 12 6Z"
                      fill="#7ABEE3"
                    />
                  </svg>
                </span>
                <img
                  className="cropArea__how-img"
                  src="https://columbusenergy.pl/lp/stopka/generator/assets/wrong.png"
                  alt=""
                />
                <div className="cropArea__how-icon">
                  <svg
                    width="21"
                    height="21"
                    viewBox="0 0 21 21"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M0.000146269 19.6304L19.6304 0L21 1.36956L1.3697 21L0.000146269 19.6304Z"
                      fill="#FD6500"
                    />
                    <path
                      d="M1.36956 4.74481e-05L20.9999 19.6304L19.6303 21L0 1.36961L1.36956 4.74481e-05Z"
                      fill="#FD6500"
                    />
                  </svg>
                </div>
                <div className="cropArea__how-info info-wrong-details">
                  <ul>
                    <li>
                      widzimy tylko część twarzy lub nie widzimy jej wcale.
                    </li>
                  </ul>
                </div>
              </div>
              <div className="cropArea__how-box">
                <p className="cropArea__how-text">Dobrze wykadrowane zdjęcie</p>
                <span className="cropArea__how-infoIcon info-correct">
                  <svg
                    width="12"
                    height="12"
                    viewBox="0 0 12 12"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M7 9.75V8.25C7 8.17708 6.97656 8.11719 6.92969 8.07031C6.88281 8.02344 6.82292 8 6.75 8H5.25C5.17708 8 5.11719 8.02344 5.07031 8.07031C5.02344 8.11719 5 8.17708 5 8.25V9.75C5 9.82292 5.02344 9.88281 5.07031 9.92969C5.11719 9.97656 5.17708 10 5.25 10H6.75C6.82292 10 6.88281 9.97656 6.92969 9.92969C6.97656 9.88281 7 9.82292 7 9.75ZM9 4.5C9 4.04167 8.85547 3.61719 8.56641 3.22656C8.27734 2.83594 7.91667 2.53385 7.48438 2.32031C7.05208 2.10677 6.60938 2 6.15625 2C4.89062 2 3.92448 2.55469 3.25781 3.66406C3.17969 3.78906 3.20052 3.89844 3.32031 3.99219L4.35156 4.77344C4.38802 4.80469 4.4375 4.82031 4.5 4.82031C4.58333 4.82031 4.64844 4.78906 4.69531 4.72656C4.97135 4.3724 5.19531 4.13281 5.36719 4.00781C5.54427 3.88281 5.76823 3.82031 6.03906 3.82031C6.28906 3.82031 6.51172 3.88802 6.70703 4.02344C6.90234 4.15885 7 4.3125 7 4.48438C7 4.68229 6.94792 4.84115 6.84375 4.96094C6.73958 5.08073 6.5625 5.19792 6.3125 5.3125C5.98438 5.45833 5.68359 5.68359 5.41016 5.98828C5.13672 6.29297 5 6.61979 5 6.96875V7.25C5 7.32292 5.02344 7.38281 5.07031 7.42969C5.11719 7.47656 5.17708 7.5 5.25 7.5H6.75C6.82292 7.5 6.88281 7.47656 6.92969 7.42969C6.97656 7.38281 7 7.32292 7 7.25C7 7.15104 7.05599 7.02214 7.16797 6.86328C7.27995 6.70443 7.42188 6.57552 7.59375 6.47656C7.76042 6.38281 7.88802 6.30859 7.97656 6.25391C8.0651 6.19922 8.1849 6.10807 8.33594 5.98047C8.48698 5.85286 8.60286 5.72786 8.68359 5.60547C8.76432 5.48307 8.83724 5.32552 8.90234 5.13281C8.96745 4.9401 9 4.72917 9 4.5ZM12 6C12 7.08854 11.7318 8.09245 11.1953 9.01172C10.6589 9.93099 9.93099 10.6589 9.01172 11.1953C8.09245 11.7318 7.08854 12 6 12C4.91146 12 3.90755 11.7318 2.98828 11.1953C2.06901 10.6589 1.34115 9.93099 0.804688 9.01172C0.268229 8.09245 0 7.08854 0 6C0 4.91146 0.268229 3.90755 0.804688 2.98828C1.34115 2.06901 2.06901 1.34115 2.98828 0.804688C3.90755 0.268229 4.91146 0 6 0C7.08854 0 8.09245 0.268229 9.01172 0.804688C9.93099 1.34115 10.6589 2.06901 11.1953 2.98828C11.7318 3.90755 12 4.91146 12 6Z"
                      fill="#7ABEE3"
                    />
                  </svg>
                </span>
                <img
                  className="cropArea__how-img"
                  src="https://columbusenergy.pl/lp/stopka/generator/assets/correct.png"
                  alt=""
                />
                <div className="cropArea__how-icon">
                  <svg
                    width="27"
                    height="20"
                    viewBox="0 0 27 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M9.40081 20L0 10.289L1.09312 9.01733L9.40081 17.5723L25.7976 0L27 1.15607L9.40081 20Z"
                      fill="#27ae60"
                    />
                  </svg>
                </div>
                <div className="cropArea__how-info info-correct-details">
                  <ul>
                    <li>
                      widzimy całą twarz, która jest umieszczona na środku
                    </li>
                    <li>
                      korzystamy tylko z profesjonalnych zdjęć firmowych, nie
                      prywatnych
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* UPLODER */}
      <form className="crop__submit">
        {/* <input type="file" name="image" onChange={this.onChangeImg} /> */}
        <button
          type="button"
          onClick={(e) => {
            cropImageNow(blob => {
              onSubmitClick(e, blob);
            });
          }}
          className="largeBtn"
        >
          Akceptuję
        </button>
      </form>
    </div>
  );
}
export default CropImageView;
